import React, { useEffect } from 'react';
import { Table, Container as ContainerSuite } from 'rsuite';
import { moeda } from '../../../components/funcoes';
import { Container, ContainerInfo } from '../styles';

const ImprimirRelatorioVendasEntregador = () => {
  const [data, setData] = React.useState({
    registros: [],
    total: 0,
  });
  const { Column, HeaderCell, Cell } = Table;
  
  useEffect(() => {
    const dataJson = JSON.parse(localStorage.getItem('relatorioVendasEntregador'));
    if(dataJson){
      setData(dataJson);
    }
  },[]);

  return (
    <ContainerSuite style={{ padding: '10px' }}>
      <Container
        style={{
          textAlign: 'center',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <ContainerInfo>
          <h3>Relatório de Vendas por Entregador</h3>
        </ContainerInfo>
      </Container>
      <Container>
        <ContainerInfo/>
        <ContainerInfo>
          <text>Valor Total: {moeda(data.total)}</text>
        </ContainerInfo>
      </Container>
      <Table height={600} data={data.registros} bordered={true}>
        <Column flexGrow={1} fixed>
          <HeaderCell>Entregador</HeaderCell>
          <Cell dataKey="Entregador" />
        </Column>

        <Column flexGrow={1}>
          <HeaderCell>Qtd. Entregas</HeaderCell>
          <Cell>{(rowData) => <text>{+(rowData.Quantidade)}</text>}</Cell>
        </Column>
        <Column>
          <HeaderCell>Valor Total</HeaderCell>
          <Cell>{(rowData) => <text>{moeda(rowData.ValorTotal)}</text>}</Cell>
        </Column>
      </Table>
    </ContainerSuite>
  );
}

export default ImprimirRelatorioVendasEntregador;